// spacing is always a multiple of 4

export const defaultSpacing = 4;

export const spacingUnits = (n: number): string => `${defaultSpacing * n}px`;
